import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { routes } from "../utils/routes"
import { rhythm } from "../utils/typography"

class Layout extends React.Component {
  render() {
    const { location, title, children } = this.props
    const rootPath = `${__PATH_PREFIX__}/`
    const blogPath = `${__PATH_PREFIX__}/blog/`

    const logo = (width, home) => (
      <svg
        className={home ? "home-icon" : "nav-icon"}
        id="Layer_1"
        // style={{ float: "left", marginRight: "15px" }}
        viewBox="0 0 512 512"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m482 308.854v-105.708c17.124-3.685 30-18.937 30-37.146 0-30.082-33.375-48.043-58.413-32.026l-75.561-75.561c16.022-25.047-1.953-58.413-32.026-58.413-37.055 0-52.257 48.031-21.563 69.266l-33.854 82.003-57.626-57.626 59.855-24.875c4.08-1.696 6.013-6.378 4.317-10.458s-6.377-6.013-10.458-4.317l-65.955 27.41-22.806-22.808c16.188-24.994-1.699-58.595-31.91-58.595-30.082 0-48.043 33.375-32.026 58.413l-75.56 75.561c-25.048-16.022-58.414 1.953-58.414 32.026 0 23.682 21.515 41.649 44.866 37.367l21.873 52.633-21.874 52.633c-23.311-4.274-44.865 13.649-44.865 37.367 0 30.082 33.375 48.043 58.413 32.026l75.561 75.56c-16.023 25.047 1.953 58.414 32.026 58.414 18.209 0 33.46-12.876 37.145-30h105.709c3.685 17.124 18.937 30 37.145 30 20.953 0 38-17.047 38-38s-17.047-38-38-38c-18.209 0-33.46 12.876-37.145 30h-102.756l236.689-98.364c21.384 30.757 69.213 15.123 69.213-21.636 0-18.209-12.876-33.46-30-37.146zm-45.382-136.076-22.143 9.142-45.816-110.246 73.549 73.548c-5.178 7.896-7.386 17.638-5.59 27.556zm6.117 14.785c5.409 7.818 13.668 13.517 23.265 15.583v102.758l-45.385-109.208zm8.394 124.252-90.398-90.398 45.094-18.616zm44.871-145.815c0 12.131-9.869 22-22 22s-22-9.869-22-22 9.869-22 22-22 22 9.869 22 22zm-150-150c12.131 0 22 9.869 22 22s-9.869 22-22 22-22-9.869-22-22 9.869-22 22-22zm-6.778 59.382c4.541.822 9.032.83 13.644-.016l46.819 112.659-51.205 21.14-45.645-45.646zm-6.759 140.396-61.723 25.482 25.482-61.723zm-173.328-140.411c9.685 1.775 19.413-.246 27.46-5.457l18.136 18.136-61.484 25.552zm-36.833 46.935-50.627 21.04 71.667-71.668zm43.698-106.302c12.131 0 22 9.869 22 22s-9.869 22-22 22-22-9.869-22-22 9.869-22 22-22zm-150 150c0-12.131 9.869-22 22-22s22 9.869 22 22-9.869 22-22 22-22-9.869-22-22zm43.636 31.213c12.166-8.459 18.461-23.191 15.731-38.079l38.231-15.888-38.195 91.907zm15.767 79.634 15.983 38.458-22.12 9.132c-2.605-3.765-5.871-7.037-9.63-9.65zm-.021 62.374 22.143-9.141 45.817 110.246-73.55-73.548c5.167-7.88 7.389-17.618 5.59-27.557zm-59.382 6.779c0-12.131 9.869-22 22-22s22 9.869 22 22-9.869 22-22 22-22-9.869-22-22zm150 150c-12.131 0-22-9.869-22-22s9.869-22 22-22 22 9.869 22 22-9.869 22-22 22zm180-44c12.131 0 22 9.869 22 22s-9.869 22-22 22-22-9.869-22-22 9.869-22 22-22zm-148.786.365c-8.443-12.144-23.161-18.465-38.079-15.732l-46.82-112.659 31.177-12.871c4.084-1.686 6.028-6.363 4.342-10.447-1.686-4.085-6.364-6.027-10.447-4.342l-31.211 12.885-22.11-53.199 50.476-121.458 82.429-34.256 66.999 66.999-34.097 82.589-54.391 22.455c-4.084 1.686-6.028 6.363-4.342 10.447 1.694 4.105 6.383 6.02 10.447 4.342l39.671-16.378-57.072 138.241c-2.179 5.276 1.724 11.055 7.392 11.055 3.143 0 6.124-1.864 7.397-4.949l63.149-152.961 82.589-34.097 97.375 97.375c-5.205 8.037-7.235 17.765-5.457 27.461zm276.786-84.365c-12.131 0-22-9.869-22-22s9.869-22 22-22 22 9.869 22 22-9.869 22-22 22z" />
        <path d="m166.459 284.312c-4.378 1.793-6.087 6.538-4.474 10.478 1.678 4.095 6.353 6.043 10.436 4.371 4.378-1.793 6.087-6.538 4.474-10.478-1.675-4.087-6.347-6.045-10.436-4.371z" />
      </svg>
    )

    let header

    if (location.pathname === rootPath) {
      header = (
        <div className="site-welcome-container">
          {logo(220, true)}
          <h1>
            <Link
              className="site-welcome-title"
              style={{
                boxShadow: `none`,
                textDecoration: `none`,
                color: `inherit`,
              }}
              to={location.pathname === blogPath ? `/blog/` : `/`}
            >
              {title}
            </Link>
          </h1>
        </div>
      )
    } else {
      header = (
        <div
          style={{
            marginBottom: rhythm(1.5),
          }}
        >
          <div className="header-container">
            <Link
              className="site-header"
              style={{
                boxShadow: `none`,
                textDecoration: `none`,
                marginBottom: "30px",
              }}
              to={`/`}
            >
              <div>{logo(110, false)}</div>
              <div className="site-title">sdesingh</div>
            </Link>

            <strong className="nav-link-container">
              {routes.map(r => (
                <Link
                  to={r.route}
                  style={{ marginRight: "20px", textDecoration: "none" }}
                >
                  <span
                    className={`nav-link ${
                      location.pathname.includes(r.route) ? "active" : ""
                    }`}
                  >
                    {r.route}
                  </span>
                </Link>
              ))}
            </strong>
          </div>
        </div>
      )
    }
    return (
      <Wrapper>
        <Container
          style={{
            marginLeft: `auto`,
            marginRight: `auto`,
            maxWidth: rhythm(28),
            padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
          }}
        >
          <header>{header}</header>
          <main>{children}</main>
        </Container>
        <Footer>{new Date().getFullYear()}</Footer>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  min-height: 100vh;
`

const Footer = styled.footer`
  text-align: center;
  margin: 24px;
`

export default Layout

const Container = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Manrope:wght@400;700&display=swap");
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap");
  @import url("https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400&display=swap");

  :root {
    --gray: #2c3842;
    --light-gray: #323f4b;
    --very-light-gray: #e9e9e9;
  }

  img {
    margin: 0;
  }

  code {
    font-family: "JetBrains Mono", monospace;
    line-height: 1.5;
  }

  em {
    margin-right: 2px;
  }

  a {
    color: #083152;
    /* text-decoration: none; */
    /* border-bottom: 2px dotted #cfcfcf; */
  }

  a:hover {
    /* border-bottom: 2px dotted #2c3842; */
  }

  p.tag {
    text-align: center;
    color: var(--light-gray);
    font-size: 0.8rem;
    margin-top: 0rem;
  }

  blockquote {
    padding: 30px;
    border-left: 10px solid #e9e9e9;
  }

  code:not(.vscode-highlight-code) {
    background: #e9e9e9;
    padding: 0.15rem 0.3rem;
    border-radius: 4px;
    margin: 0px 1px;
  }

  .button {
    background: #2c3842;
  }

  .button:hover {
    background: #323f4b;
  }

  .site-title {
    font-family: "Manrope";
    font-size: 2em;
    font-weight: 600;
  }

  .home-icon {
    fill: #323f4b;
  }

  .blog-post-link {
    text-decoration: none;
  }

  .blog-post-link:hover {
    border-bottom: 3px dotted #2c3842;
  }

  .home-nav-container {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(4, 1fr);
  }

  .nav-icon {
    fill: #323f4b;
  }

  .nav-link {
    padding-bottom: 2px;

    font-family: monospace;
    font-size: 1rem;
    color: #bbbbbb;
    text-decoration: none;
  }

  .site-welcome-container {
    text-align: center;
    margin-top: 4em;
  }

  .site-welcome-title {
    font-size: 1.5em;
    color: #2c3842;
  }

  .nav-link.active {
    color: #323f4b;
    border-bottom: 2px dotted #323f4b;
  }

  .nav-link:hover {
    color: #323f4b;
  }

  .home-nav-container > a > button {
    width: 100%;
  }

  .home-nav-card {
    text-align: center;
    line-height: 100px;
    /* background: #2c3842; */
  }

  .home-nav-card:hover {
    /* background: #323f4b; */
  }

  .project-cards-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
  }

  .project-card {
    opacity: 0.45;
    cursor: pointer;
    border-radius: 8px;
    margin-bottom: 0;
  }

  .project-card:hover,
  .project-card:focus {
    opacity: 1;
  }

  .job-time {
    float: right;
  }

  .resume-links {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 50px;
  }

  /* Media Queries */

  @media only screen and (max-width: 630px) {
    body {
      font-size: 0.7em;
    }

    h1 {
      font-size: 1.8em;
    }

    h2 {
      font-size: 1.4em;
    }

    h3 {
      font-size: 1.1em;
    }

    code {
      padding: 2px;
      line-height: 1.333;
      font-size: 0.8em;
    }

    .site-title {
      color: var(--gray);
    }

    .site-welcome-container {
      margin-top: 10px;
    }
    .site-welcome-title {
      font-size: 1.5em;
    }

    .home-nav-container {
      display: grid;
      grid-template-columns: 1fr;
    }

    .header-container {
      text-align: center;
      margin: auto;
      width: 100%;
      margin-bottom: 1.5rem;
    }

    .nav-icon {
      margin-bottom: 20px;
    }
  }

  @media only screen and (min-width: 631px) {
    .nav-icon {
      float: left;
      margin-top: 0;
      margin-right: 25px;
      fill: #bbbbbb;
    }
  }
`
